__turbopack_context__.v({
  "className": "figtree_8e293220-module__QD09Ka__className",
});
